document.addEventListener('click', function (e) {
  const btn = e.target.closest('button.localization-flag[name="locale_code"]');
  if (!btn) return;

  const form = btn.closest('form[action="/localization"]');
  if (!form) return;

  e.preventDefault();

  const val = btn.value;
  console.log('[locale] click', val);

  // Ensure hidden input exists (some themes rely on it)
  let hidden = form.querySelector('input[type="hidden"][name="locale_code"]');
  if (!hidden) {
    hidden = document.createElement('input');
    hidden.type = 'hidden';
    hidden.name = 'locale_code';
    form.appendChild(hidden);
  }
  hidden.value = val;

  // Ensure return_to exists
  let rt = form.querySelector('input[type="hidden"][name="return_to"]');
  if (!rt) {
    rt = document.createElement('input');
    rt.type = 'hidden';
    rt.name = 'return_to';
    form.appendChild(rt);
  }
  if (!rt.value) rt.value = location.pathname + location.search;

  form.submit();
}, true);

document.addEventListener('DOMContentLoaded', function () {
  const trigger = document.querySelector('.header__icons-search');
  const search = document.querySelector('.header__search');

  if (!trigger || !search) return;

  trigger.addEventListener('click', function (e) {
    e.preventDefault();
    search.classList.toggle('is-open');
  });
});

document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', function (event) {
    if (!event.target || typeof event.target.closest !== 'function') return;
    var mobileWishlistTrigger = event.target.closest('[data-mobile-wishlist-trigger]');
    if (!mobileWishlistTrigger) return;

    event.preventDefault();

    var drawerDetails = mobileWishlistTrigger.closest('#Details-menu-drawer-container');
    var drawerSummary = drawerDetails ? drawerDetails.querySelector(':scope > summary') : null;
    if (drawerDetails && drawerDetails.hasAttribute('open') && drawerSummary) {
      drawerSummary.click();
    }

    var wishlistLauncher = document.querySelector('.swym-header-launcher');
    if (wishlistLauncher) wishlistLauncher.click();
  });

  function isMobile() {
    return window.innerWidth <= 640;
  }

  function normalizeText(text) {
    return (text || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function patchTutorialMenu() {
    if (!isMobile()) return;

    var link = document.getElementById('HeaderDrawer-magazin');
    if (!link) return;

    var list = link.closest('.menu-drawer__menu');
    if (!list) return;

    if (list.dataset.tutorialsPatched === 'true') return;

    var items = Array.from(list.children).filter(function (el) {
      return el && el.tagName && el.tagName.toLowerCase() === 'li';
    });

    var anleitungenItem = null;
    var handarbeitenItem = null;
    var tutorialsItem = null;

    items.forEach(function (item) {
      var a = item.querySelector('a');
      if (!a) return;

      var textEl = a.querySelector('.menu-drawer__menu-item-text');
      var text = normalizeText(textEl ? textEl.textContent : a.textContent);
      var id = a.id || '';
      var href = a.getAttribute('href') || '';

      if (
        id === 'HeaderDrawer-magazin' ||
        href.indexOf('/blogs/magazin') !== -1 ||
        text === 'magazin'
      ) {
        handarbeitenItem = item;

        if (textEl) {
          textEl.textContent = '#handarbeiten';
        } else {
          a.textContent = '#handarbeiten';
        }
        return;
      }

      if (text === 'anleitungen') {
        anleitungenItem = item;
        return;
      }

      if (text === 'tutorials') {
        tutorialsItem = item;
      }
    });

    if (!anleitungenItem || !handarbeitenItem || !tutorialsItem) return;

    list.insertBefore(tutorialsItem, list.firstChild);
    list.insertBefore(anleitungenItem, list.firstChild);

    list.dataset.tutorialsPatched = 'true';
  }

  patchTutorialMenu();

  document.addEventListener('click', function () {
    setTimeout(patchTutorialMenu, 50);
    setTimeout(patchTutorialMenu, 250);
  });

  window.addEventListener('resize', function () {
    document.querySelectorAll('.menu-drawer__menu').forEach(function (list) {
      delete list.dataset.tutorialsPatched;
    });

    setTimeout(patchTutorialMenu, 100);
  });
});

document.addEventListener('DOMContentLoaded', function () {
  var reviewWrappers = document.querySelectorAll('.trusted-shops-product-widget');
  if (!reviewWrappers.length) return;

  var nativeReviewSizing = window.CSS && CSS.supports('zoom', '1');
  var reviewResizeFrame = 0;

  function scheduleTrustedShopsListHeight() {
    if (nativeReviewSizing || reviewResizeFrame) return;
    reviewResizeFrame = window.requestAnimationFrame(function () {
      reviewResizeFrame = 0;
      adjustTrustedShopsListHeight();
    });
  }

  function adjustTrustedShopsListHeight() {
    if (nativeReviewSizing) return;
    document.querySelectorAll('.trusted-shops-product-widget--list').forEach(function (wrapper) {
      var widget = wrapper.querySelector('etrusted-widget');
      if (!widget) return;

      var scale = parseFloat(window.getComputedStyle(wrapper).getPropertyValue('--trusted-shops-list-scale')) || 1;
      var rawHeight = wrapper.offsetHeight;

      if (!rawHeight || scale >= 1) {
        wrapper.style.removeProperty('--trusted-shops-list-compensation');
        return;
      }

      wrapper.style.setProperty(
        '--trusted-shops-list-compensation',
        Math.round(rawHeight * (scale - 1)) + 'px'
      );
    });
  }

  var observedTrustedShopsListWidgets = typeof WeakSet === 'function' ? new WeakSet() : null;
  var trustedShopsListResizeObserver = !nativeReviewSizing && 'ResizeObserver' in window
    ? new ResizeObserver(scheduleTrustedShopsListHeight)
    : null;

  function observeTrustedShopsListWidget(widget) {
    if (!widget || !trustedShopsListResizeObserver) return;
    if (observedTrustedShopsListWidgets && observedTrustedShopsListWidgets.has(widget)) return;

    trustedShopsListResizeObserver.observe(widget);
    if (observedTrustedShopsListWidgets) observedTrustedShopsListWidgets.add(widget);
  }

  function getTrustedShopsComponentConfigs() {
    return Array.prototype.map.call(document.querySelectorAll('[data-prp-config]'), function (configElement) {
      try {
        return JSON.parse(configElement.textContent || '{}');
      } catch (error) {
        return null;
      }
    }).filter(Boolean);
  }

  function findTrustedShopsComponentConfig(variantId, sectionId) {
    var variantKey = String(variantId || '');
    var configs = getTrustedShopsComponentConfigs();

    return configs.find(function (config) {
      if (sectionId && String(config.sectionId) !== String(sectionId)) return false;
      return config.sets && Object.prototype.hasOwnProperty.call(config.sets, variantKey);
    });
  }

  function getTrustedShopsComponentIdentifierForVariant(config, variantId) {
    if (!config) return null;

    var variantKey = String(variantId || '');
    var items = config.sets && config.sets[variantKey] ? config.sets[variantKey] : [];
    var skuIdentifiers = [];
    var gtinIdentifiers = [];

    items.forEach(function (item) {
      var quantity = Number(item.quantity || 0);
      var itemType = String(item.product_variation_names || '').trim().toLowerCase();
      var sku = String(item.trusted_shops_sku || '').trim();
      var gtin = String(item.trusted_shops_gtin || '').trim();

      if (quantity <= 0 || item.requires_shipping === false || itemType === 'digital') return;
      if (sku && skuIdentifiers.indexOf(sku) === -1) {
        skuIdentifiers.push(sku);
      } else if (!sku && gtin && gtinIdentifiers.indexOf(gtin) === -1) {
        gtinIdentifiers.push(gtin);
      }
    });

    if (skuIdentifiers.length) return { type: 'sku', value: skuIdentifiers.join(',') };
    if (gtinIdentifiers.length) return { type: 'gtin', value: gtinIdentifiers.join(',') };

    return null;
  }

  function getTrustedShopsParentIdentifiersForVariant(config, variantId) {
    if (!config) return [];

    var variantKey = String(variantId || '');
    var parentVariant = (config.variants || []).find(function (variant) {
      return String(variant.id) === variantKey;
    });

    if (!parentVariant) return [];

    var parentSku = String(parentVariant.trusted_shops_sku || '').trim();
    var parentGtin = String(parentVariant.trusted_shops_gtin || '').trim();
    if (parentSku) {
      var identifiers = [{ type: 'sku', value: parentSku }];
      var skuMatch = parentSku.match(/^(.*)\.(\d+)$/);

      if (skuMatch) {
        var sharedSku = skuMatch[1];
        var sharedSkuPrefix = sharedSku + '.';
        var matchingVariantCount = (config.variants || []).filter(function (variant) {
          var variantSku = String(variant.trusted_shops_sku || '').trim();
          var suffix = variantSku.indexOf(sharedSkuPrefix) === 0
            ? variantSku.slice(sharedSkuPrefix.length)
            : '';

          return suffix && /^\d+$/.test(suffix);
        }).length;

        // Shopware stored set reviews on the shared parent SKU, while Shopify
        // uses numbered SKUs for the size variants (for example .1 through .4).
        if (matchingVariantCount > 1) {
          identifiers.push({ type: 'sku', value: sharedSku });
        }
      }

      return identifiers;
    }
    if (parentGtin) return [{ type: 'gtin', value: parentGtin }];
    return [];
  }

  var trustedShopsReviewAvailability = typeof Map === 'function' ? new Map() : {};

  function getTrustedShopsEncodedSku(identifier) {
    return Array.prototype.map.call(unescape(encodeURIComponent(identifier)), function (character) {
      return character.charCodeAt(0).toString(16);
    }).join('');
  }

  function getTrustedShopsReviewAvailability(wrapper, identifier) {
    if (!identifier || !identifier.value) return Promise.resolve(null);

    var cacheKey = identifier.type + ':' + identifier.value;
    var cached = trustedShopsReviewAvailability instanceof Map
      ? trustedShopsReviewAvailability.get(cacheKey)
      : trustedShopsReviewAvailability[cacheKey];
    if (cached) return cached;

    var template = wrapper.dataset.trustedShopsGradesUrlTemplate;
    if (!template || typeof fetch !== 'function') return Promise.resolve(null);

    var encodedIdentifier = identifier.type === 'sku'
      ? getTrustedShopsEncodedSku(identifier.value)
      : encodeURIComponent(identifier.value);
    var url = template
      .replace('{type}', identifier.type)
      .replace('{identifier}', encodedIdentifier);
    var request = fetch(url, { credentials: 'omit' })
      .then(function (response) {
        if (!response.ok) throw new Error('Trusted Shops grade feed unavailable');
        return response.json();
      })
      .then(function (data) {
        return Boolean(data && data.grades && data.grades.overall && Number(data.grades.overall.count) > 0);
      })
      .catch(function () {
        // Keep the set's own widget when the availability request fails.
        return null;
      });

    if (trustedShopsReviewAvailability instanceof Map) {
      trustedShopsReviewAvailability.set(cacheKey, request);
    } else {
      trustedShopsReviewAvailability[cacheKey] = request;
    }
    return request;
  }

  function replaceTrustedShopsWidget(wrapper, identifier) {
    var currentWidget = wrapper.querySelector('etrusted-widget');
    var identifierAttribute = 'data-' + identifier.type;
    var otherIdentifierAttribute = identifier.type === 'sku' ? 'data-gtin' : 'data-sku';
    if (
      !currentWidget ||
      (currentWidget.getAttribute(identifierAttribute) === identifier.value && !currentWidget.hasAttribute(otherIdentifierAttribute))
    ) return;

    // Keep the allocated space while the replacement custom element hydrates.
    // In particular, a temporarily empty review list must not pull the footer upward.
    var reservedHeight = wrapper.getBoundingClientRect().height;
    if (reservedHeight > 0) wrapper.style.minHeight = reservedHeight + 'px';

    var newWidget = document.createElement('etrusted-widget');
    ['data-etrusted-widget-id', 'data-locale'].forEach(function (attributeName) {
      var attributeValue = currentWidget.getAttribute(attributeName);
      if (attributeValue) newWidget.setAttribute(attributeName, attributeValue);
    });
    newWidget.setAttribute(identifierAttribute, identifier.value);

    if (trustedShopsListResizeObserver && wrapper.classList.contains('trusted-shops-product-widget--list')) {
      trustedShopsListResizeObserver.unobserve(currentWidget);
    }
    currentWidget.replaceWith(newWidget);

    if (wrapper.classList.contains('trusted-shops-product-widget--list')) {
      observeTrustedShopsListWidget(newWidget);
    }
  }

  function combineTrustedShopsIdentifiers(identifiers) {
    if (!identifiers || !identifiers.length) return null;

    var identifierType = identifiers[0].type;
    var values = identifiers.reduce(function (result, identifier) {
      if (identifier.type !== identifierType || !identifier.value || result.indexOf(identifier.value) !== -1) {
        return result;
      }

      result.push(identifier.value);
      return result;
    }, []);

    return values.length ? { type: identifierType, value: values.join(',') } : null;
  }

  function refreshTrustedShopsComponentReviews(variantId, sectionId) {
    var config = findTrustedShopsComponentConfig(variantId, sectionId);
    var componentIdentifier = getTrustedShopsComponentIdentifierForVariant(config, variantId);
    var parentIdentifiers = getTrustedShopsParentIdentifiersForVariant(config, variantId);
    if (!config || !componentIdentifier || !parentIdentifiers.length) return;

    document.querySelectorAll('[data-trusted-shops-review-fallback]').forEach(function (wrapper) {
      if (String(wrapper.dataset.trustedShopsProductId || '') !== String(config.productId || '')) return;

      var requestVariantKey = String(variantId || '');
      wrapper.dataset.trustedShopsRequestVariant = requestVariantKey;
      Promise.all(parentIdentifiers.map(function (parentIdentifier) {
        return getTrustedShopsReviewAvailability(wrapper, parentIdentifier);
      })).then(function (availability) {
        if (wrapper.dataset.trustedShopsRequestVariant !== requestVariantKey) return;

        if (availability.some(function (hasReviews) { return hasReviews === true; })) {
          // Keep both Shopify's exact variant SKU and Shopware's shared set SKU
          // so reviews collected under either identifier are shown together.
          var combinedParentIdentifier = combineTrustedShopsIdentifiers(parentIdentifiers);
          if (combinedParentIdentifier) replaceTrustedShopsWidget(wrapper, combinedParentIdentifier);
        } else if (availability.every(function (hasReviews) { return hasReviews === false; })) {
          replaceTrustedShopsWidget(wrapper, componentIdentifier);
        }
      });
    });

    scheduleTrustedShopsListHeight();
  }

  if (!nativeReviewSizing) {
    adjustTrustedShopsListHeight();
    window.addEventListener('load', scheduleTrustedShopsListHeight);
    window.addEventListener('resize', scheduleTrustedShopsListHeight);
  }

  document.querySelectorAll('.trusted-shops-product-widget--list etrusted-widget').forEach(observeTrustedShopsListWidget);

  document.addEventListener('prp:selection-change', function (event) {
    var variantId = event.detail && event.detail.recipeVariant ? event.detail.recipeVariant.id : null;
    if (variantId) refreshTrustedShopsComponentReviews(variantId);
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var eventData = event && event.data ? event.data : {};
      if (eventData.variant && eventData.variant.id) {
        refreshTrustedShopsComponentReviews(eventData.variant.id, eventData.sectionId);
      }
    });
  }

  getTrustedShopsComponentConfigs().forEach(function (config) {
    if (config.initialVariantId) {
      refreshTrustedShopsComponentReviews(config.initialVariantId, config.sectionId);
    }
  });
});
